import { render, staticRenderFns } from "./ActivationPreviewProvider.vue?vue&type=template&id=0872b474&"
import script from "./ActivationPreviewProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationPreviewProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports